import { Stack, SxProps, Typography } from "@mui/material";
import IconCopy from "../common/IconCopy";

type KeyCellProps = {
  label: string;
  value?: string;
  allowCopyValue?: boolean;
  sx?: SxProps;
};

const KeyCell = ({ label, value, allowCopyValue, sx }: KeyCellProps) => {
  return (
    <Stack direction="column" spacing={1} sx={{ paddingBottom: "22px", paddingTop: "2px", ...sx }}>
      <Typography variant="body.small.regular">{label}</Typography>
      <Stack direction="row" sx={{ alignItems: "center" }}>
        <Typography variant={value ? "body.medium.semibold" : "body.medium.regular"}>
          {value || "Not specified"}
        </Typography>
        {allowCopyValue && <IconCopy clipboard={value} />}
      </Stack>
    </Stack>
  );
};

export { KeyCell };
